import React, { useState } from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import FinanceCardChart from "../financeCardChart/financeCardChart";
import InfoIcon from "../../../assets/icons/info-icon.svg";

ChartJS.register(ArcElement, Tooltip, Legend);

const FinanceDebts = ({ delinquency = {}, code }) => {
  const [showPopover, setShowPopover] = useState(false);

  const data = {
    labels: ["Inadimplentes", "Em dia"],
    datasets: [
      {
        label: "Distribuição de Pagamentos",
        data: [
          delinquency.overdueValuePercentage ?? 0,
          delinquency.onTimeValuePercentage ?? 0
        ],
        backgroundColor: ["#DA5252", "#0962AD"],
        borderColor: ["#DA5252", "#0962AD"],
        borderWidth: 0
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          usePointStyle: true,
          boxHeight: 6,
          color: "#858585",
          font: { size: 14 }
        }
      },
      tooltip: {
        callbacks: {
          label: (tooltipItem) => {
            const value = tooltipItem.raw;
            return `${value.toFixed(2)}%`;
          }
        }
      }

    }
  };

  return (
    <FinanceCardChart
      code={code}
      title={
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          <span>Inadimplência</span>
          <div style={{ position: 'relative' }}>
            <img
              src={InfoIcon}
              alt="Informação"
              onClick={() => setShowPopover(!showPopover)}
              style={{
                width: '14px',
                height: '14px',
                cursor: 'pointer',
                verticalAlign: 'middle',
                display: 'inline-block',
              }}
            />
            {showPopover && (
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "100%",
                  transform: "translate(0, -50%)",
                  marginLeft: "8px",
                  backgroundColor: "#fff",
                  border: "1px solid #ccc",
                  padding: "10px",
                  zIndex: 100,
                  width: "220px",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                  borderRadius: "4px"
                }}
              >
                <p style={{ margin: 0, fontSize: "12px", fontWeight: "normal" }}>
                  Inadimplentes representa a % do valor de parcelas vencidas. Em dia representa a % do valor de parcelas pagas em dia.
                </p>
                <button
                  onClick={() => setShowPopover(false)}
                  style={{
                    marginTop: "8px",
                    fontSize: "10px",
                    cursor: "pointer",
                    background: "none",
                    border: "none",
                    color: "#0962AD"
                  }}
                >
                  Fechar
                </button>
              </div>
            )}
          </div>
        </div>
      }
    >
      <div style={{ width: "100%", height: "100%" }}>
        <Doughnut data={data} options={options} />
      </div>
    </FinanceCardChart>
  );
};

export default FinanceDebts;
